import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inviteActionButtons"},[(!_vm.sent)?_c(VBtn,{attrs:{"color":"primary","fab":"","x-small":"","disabled":_vm.loading,"loading":_vm.loading},on:{"click":function($event){return _vm.resend()}}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":_vm.icons.resend}})],1):_c('font-awesome-icon',{staticClass:"fa-2x",staticStyle:{"color":"green"},attrs:{"icon":_vm.icons.sent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }